import { useEffect, useRef } from 'react'

/**
 * Custom react hook
 * This returns the mount status of a functional component
 * @return {boolean} isMount - mount state of a functional component. default: true
 */
const useMountStatus = () => {
	const isMountRef = useRef(true)
	useEffect(() => {
		isMountRef.current = false
	}, [])
	return isMountRef.current
}

export default useMountStatus
